/*
  Member reviews — Swiper init for sections/member-reviews.liquid.

  Swiper itself is loaded once in the layout, so this only wires up the
  instances. Each section is initialised against its own arrows and dots rather
  than the bundle's default `swiper-button-prev` / `swiper-pagination-bullet`
  classes, which keeps the control styling in section-member-reviews.css and
  keeps two carousels on one page from driving each other.
*/
(function () {
  const READY = 'memberReviewsReady';

  function initCarousel(viewport) {
    // shopify:section:load fires on the editor's own re-renders as well, so a
    // viewport that already has a Swiper on it is left alone.
    if (viewport.dataset[READY] === 'true') return;

    const section = viewport.closest('.member-reviews');
    if (!section) return;

    viewport.dataset[READY] = 'true';

    // How many cards the widest breakpoint shows, set in the theme editor. The
    // group matches it at every width so the arrows move a whole page and the
    // dots count pages rather than cards.
    const columns = parseInt(viewport.dataset.columns, 10) || 3;

    new Swiper(viewport, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 16,
      watchOverflow: true,
      keyboard: {enabled: true},
      a11y: {enabled: true},
      navigation: {
        prevEl: section.querySelector('[data-member-reviews-prev]'),
        nextEl: section.querySelector('[data-member-reviews-next]'),
        disabledClass: 'member-reviews__arrow--disabled',
        lockClass: 'member-reviews__arrow--locked',
      },
      pagination: {
        el: section.querySelector('[data-member-reviews-pagination]'),
        clickable: true,
        bulletClass: 'member-reviews__dot',
        bulletActiveClass: 'member-reviews__dot--active',
        lockClass: 'member-reviews__dots--locked',
        clickableClass: 'member-reviews__dots--clickable',
      },
      breakpoints: {
        750: {slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 20},
        990: {slidesPerView: columns, slidesPerGroup: columns, spaceBetween: 24},
      },
    });
  }

  function initAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-member-reviews]').forEach(initCarousel);
  }

  function start() {
    if (typeof Swiper === 'undefined') return;
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Re-init the one section the theme editor just re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    if (typeof Swiper === 'undefined') return;
    initAll(event.target);
  });
})();
